import { render, staticRenderFns } from "./OffersCard.vue?vue&type=template&id=ec1d9e8c&scoped=true"
import script from "./OffersCard.vue?vue&type=script&lang=js"
export * from "./OffersCard.vue?vue&type=script&lang=js"
import style0 from "./OffersCard.vue?vue&type=style&index=0&id=ec1d9e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1d9e8c",
  null
  
)

export default component.exports